/** Marketing site / download artifact version (keep in sync with CHANGELOG). */
export const SITE_VERSION = "0.3.8";
